<ng-container *transloco="let t">
  <div class="flex flex-col gap-2">
    <!-- Label -->
    @if (props.label) {
      <label [for]="id" class="font-semibold">
        {{ props.label }}
        @if (isRequired) {
          <span class="text-red-500">*</span>
        }
      </label>
    }

    <!-- Expiry date -->
    @if (props.expiry) {
      <div class="flex flex-row items-center gap-2">
        <i class="pi pi-clock text-yellow-600 dark:text-yellow-400 text-sm"></i>
        <p class="text-yellow-600 dark:text-yellow-400 text-sm">
          {{
            t("app.fileUpload.expiryMessage", {
              amount: props.expiry.amount,
              units: getExpiryUnits(props.expiry),
            })
          }}
        </p>
      </div>
    }

    <!-- File Upload -->
    <app-file-upload
      [name]="field.key?.toString() || 'files'"
      [fileTypes]="fileTypes"
      [maxFileSize]="maxFileSize"
      [disabled]="formControl.disabled"
      [isInvalid]="isInvalid"
      [isDirty]="formControl.dirty"
      [files]="files"
      (filesChange)="onFilesChange($event)"
    />

    <!-- Description -->
    @if (props.description) {
      <div class="text-sm text-surface-600 dark:text-surface-200 mt-1">
        {{ props.description }}
      </div>
    }

    <!-- Validation Message -->
    @if (isInvalid) {
      <div class="text-red-500 text-sm">
        @if (formControl.errors?.["required"]) {
          <span>{{ t("app.formly-types.validationMessages.fieldRequired") }}</span>
        }
      </div>
    }
  </div>
</ng-container>
